export default [
  { id: 'amount', label: 'Amount' },
  { id: 'label', label: 'Label' },
  { id: 'serving', label: 'Serving' },
  { id: 'unit', label: 'Unit' },
  { id: 'variant', label: 'Variant' },
];